/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { useState } from 'react';
import IdleTimer from 'react-idle-timer';
import { useDispatch, useSelector } from 'react-redux';
import { IDLE_TIMER_INACTIVE, IDLE_TIMER_LOGOUT } from '../../constants';
import { Selectors } from '../../selectors';
import { Thunks, Actions } from '../../actions';
import { ConfirmationPopUp } from '../ConfirmationPopUp/ConfirmationPopUp';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { TimerLeft } from '../TimerLeft/TimerLeft';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useAuthHelper, useAuthState, getUserId } from '../AuthContextProvider';
import { useHistory } from 'react-router-dom';
import * as PXBColors from '@brightlayer-ui/colors';

const useStyles = makeStyles(() => ({
    largeIcon: {
        width: 60,
        height: 60,
        color: PXBColors.gray[500],
    },
}));
export const IdleTimerContainer: React.FC = () => {
    const classes = useStyles();
    const { t } = useLanguageLocale();
    const dispatch = useDispatch();
    const authHelper = useAuthHelper();
    const history = useHistory();
    const authState = useAuthState();
    const userId = getUserId(authState);
    const idleTimerSetting = useSelector(Selectors.User.session);
    const [timeout, settimeout] = useState(IDLE_TIMER_INACTIVE);
    const [showModal, setshowModal] = useState(false);
    const isTimeout = useState(false);
    const setIsTimeOut = isTimeout[1];
    let idleTimer = null;

    const logoutSession = React.useCallback(() => {
        setshowModal(false);
        dispatch(Actions.Dashboard.inActiveLogOut(true));
        dispatch(Thunks.Authentication.logout(userId, history, authHelper.onUserNotAuthenticated));
    }, [dispatch, history, userId, authHelper.onUserNotAuthenticated]);

    const extend = React.useCallback(() => {
        setshowModal(false);
        setIsTimeOut(false);
        settimeout(IDLE_TIMER_INACTIVE);
    }, [setIsTimeOut]);

    const onAction = (): void => {
        setIsTimeOut(false);
    };

    const onActive = (): void => {
        setIsTimeOut(false);
    };
    const onIdle = (): void => {
        if (!idleTimerSetting) {
            setshowModal(false);
            settimeout(IDLE_TIMER_INACTIVE);
            setIsTimeOut(false);
        } else {
            setshowModal(true);
            settimeout(IDLE_TIMER_INACTIVE);
            setIsTimeOut(true);
        }
    };
    return (
        <>
            {idleTimerSetting && (
                <IdleTimer
                   
                    ref={(ref: IdleTimer): any => { idleTimer = ref }}
                    element={document}
                    onActive={onActive}
                    onIdle={onIdle}
                    onAction={onAction}
                    debounce={250}
                    timeout={timeout}
                />
            )}
            {idleTimerSetting && (
                <ConfirmationPopUp
                    icon={<AccessTimeIcon className={classes.largeIcon} />}
                    title={t('INACTIVITY.TITLE')}
                    body={
                        <>
                            <Typography variant="subtitle1" style={{ marginBottom: 50 }}>
                                {t('INACTIVITY.WARNING')}
                                <TimerLeft
                                    minutes={IDLE_TIMER_LOGOUT}
                                    timeout={(): void => {
                                        logoutSession();
                                    }}
                                />
                                {t('INACTIVITY.LOGOUT')}
                            </Typography>
                        </>
                    }
                    cancelButtonText={t('ACTIONS.LOG_OUT')}
                    okButtonText={t('ACTIONS.EXTEND')}
                    show={showModal}
                    closeDialog={(): void => {
                        logoutSession();
                    }}
                    handleOk={(): void => {
                        extend();
                    }}
                    okButtonShow={true}
                    cancelButtonsShow={true}
                    width="xs"
                ></ConfirmationPopUp>
            )}
        </>
    );
};
